import React from "react";
import useGameStore from "../store/gameStore";
import LeaderboardRecord from "./LeaderboardRecord";

function Leaderboard() {
  const leaderboards = useGameStore((s) => s.leaderboards);

  const colors = [
    "#FF3939",
    "#FF7918",
    "#FFD130",
    "#8ADE63",
    "#558FFF",
    "#9666FC",
  ];

  const items = Array.isArray(leaderboards)
    ? leaderboards
        .slice()
        .sort((a, b) => b.score - a.score)
        .map((record, i) => ({
          key: record.name + record.score,
          posColor: colors[i],
          place: i + 1,
          player: record.name,
          score: record.score,
        }))
    : [];

  return (
    <div
      className="leaderboard"
      style={{
        zIndex: "6",
        width: "350px",
        height: "440px",
        backgroundColor: "#d9d9d9",
        position: "absolute",
        borderRadius: "45px",
        padding: "40px",
        display: "flex",
        flexDirection: "column",
        gap: "5px",
        alignItems: "center",
        fontFamily: "Jua, sans-serif",
        left: "50%",
        top: "calc(50% - 45px)",
        transform: "translate(-50%, -50%)",
      }}
    >
      <h2 style={{ marginBottom: "15px" }}>top players & scores</h2>
      {items.map((item) => (
        <div key={item.key}>
          <LeaderboardRecord
            posColor={item.posColor}
            place={item.place}
            player={item.player}
            score={item.score}
          />
        </div>
      ))}
    </div>
  );
}

export default Leaderboard;
